import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

interface EnvConfig {
  label: string;
  bgColor: string;
  detailBg: string;
}

const ENV_CONFIG: Record<string, EnvConfig> = {
  local: { label: 'LOCAL', bgColor: '#3b82f6', detailBg: '#2563eb' },
  test: { label: 'TEST', bgColor: '#b91c1c', detailBg: '#991b1b' },
};

@Component({
  selector: 'environment-badge',
  templateUrl: './environment-badge.component.html',
  styleUrls: ['./environment-badge.component.scss'],
})
export class EnvironmentBadgeComponent {
  showDetail = false;
  config = ENV_CONFIG[environment.environment];

  detailItems = [
    { label: 'API', value: environment.apiDomain },
    { label: 'Site', value: environment.webDomain },
    { label: 'Version', value: environment.version },
  ];

  toggleDetail(): void {
    this.showDetail = !this.showDetail;
  }
}
